<script>
import { onMount, onDestroy, tick } from 'svelte';
import { fade } from 'svelte/transition';
import { createPopper } from '@popperjs/core';


export let target = null;
export let placement = 'top';
export let html = '';
let container;
let popper;
const preventOverflow = {
  name: 'preventOverflow',
  options: { padding: 4 },
}

$: updatePlacement(html);
$: updateTooltip(target);


function highlight(html) {
  return html.replace(/<highlight>/g, '<span class="highlight">').replace(/<\/highlight>/g, '</span>');
}

function updatePlacement() {
  try {
    if (popper) popper.update();
  } catch (err) {/* May or may not help */}
}

function updateTooltip() {
  if (popper) popper.destroy();
  if (!container || !target) return;
  popper = createPopper(target, container, {
    placement,
    modifiers: [ preventOverflow ]
  });
}

onMount(() => {
  updateTooltip();
  container.classList.add('in');
  setTimeout(updateTooltip, 100);
});

onDestroy(() => {
  try {
    if (popper) popper.destroy();
  } catch (err) {/* may have already been destroyed */}
});
</script>

<div bind:this={container} class="tooltip" role="tooltip">
  <div class="tooltip-arrow" data-popper-arrow></div>
  <div class="tooltip-inner">{@html highlight(html) }</div>
</div>
